module.exports = __webpack_public_path__ + "static/media/excessive-drive-dark.52742592.svg";